const weatherBubbles = [
    {
        title: "Clear",
        description: "clear sky",
        icon: "01d",
        background: "radial-gradient(50% 50% at 50% 50%, #FFFFFF 12%, #6FACE5 100%)",
    },
    {
        title: "Few Clouds",
        description: "few clouds",
        icon: "02d",
        background: "#74a1d1",
    },
    {
        title: "Scattered Clouds",
        description: "scattered clouds",
        icon: "03d",
        background: "linear-gradient(0deg, #CEE7FF 0%, #1A68B0 100%)",
    },
    {
        title: "Broken Clouds",
        description: "broken clouds",
        icon: "04d",
        background: "#74a1d1",
    },
    {
        title: "Drizzle",
        description: "drizzle",
        icon: "09d",
        background: "linear-gradient(0deg, #A7D4FF 2.08%, #ADCEEC 14.25%, #83939F 100%)",
    },
    {
        title: "Rain",
        description: "rain",
        icon: "10d",
        background: "linear-gradient(180deg, #092234 0%, #657E8F 58.85%, #ACC4D6 100%)",
    },
    {
        title: "Thunderstorm",
        description: "thunderstorm",
        icon: "11d",
        background: "#434D5D",
    },
    {
        title: "Snow",
        description: "snow",
        icon: "13d",
        background: "linear-gradient(10deg, #C9D3DC 0%, #FFFFFF 100%)",
    },
    {
        title: "Atmosphere",
        description: "mist",
        icon: "50d",
        background: "linear-gradient(180deg, #67849F 0%, #C4CFD9 66.67%, #E4E4E4 100%)",
    }
];

export default weatherBubbles;